import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import { serializeImage } from '../../utils/SerializeImage';
import BackgroundImage from '../BackgroundImage';
import styles from './MapInfoWindow.module.scss';

const MapInfoWindow = ({ href = '', readMore, title = '', image = {} }) => {
    const { t } = useTranslation('common');

    const isExternalLink = href && !href.includes('visitsweden.');
    const isGoogleMapsLink = href && href.includes('maps.google.com');
    const url = href && !isExternalLink ? `${href}?from_map=1` : href;

    // These translations doesn't seem to work, maybe loaded too late, so make sure text is passed to this component
    const defaultReadMore = isGoogleMapsLink
        ? t('mapInfoWindow.goToMap')
        : t('mapInfoWindow.readMore');
    const readMoreText = readMore || defaultReadMore;

    const serializedImage = serializeImage(image);
    const sizes = '(min-width: 345px) 95px, 80px';
    const hasImage = image && image?.src;

    const classes = classNames(
        styles['MapInfoWindow'],
        { [styles['MapInfoWindow--HasImage']]: hasImage },
        { [styles['MapInfoWindow--External']]: isExternalLink }
    );

    return (
        <div className={classes}>
            <a
                className={styles['MapInfoWindow__Link']}
                href={url}
                target={isExternalLink ? '_blank' : '_self'}
                rel="noreferrer"
                aria-label={`${title}: ${readMoreText}`}
            />
            <div className={styles['MapInfoWindow__Container']}>
                {hasImage && (
                    <div className={styles['MapInfoWindow__Image']}>
                        <BackgroundImage
                            {...serializedImage}
                            sizes={sizes}
                            quality={60}
                            shouldLazyLoad={false}
                            hideAlt={true}
                        />
                    </div>
                )}
                <div className={styles['MapInfoWindow__Content']}>
                    <div className={styles['MapInfoWindow__Text']}>{title}</div>
                    <div className={styles['MapInfoWindow__ReadMore']}>
                        {readMoreText}
                    </div>
                </div>
            </div>
        </div>
    );
};

MapInfoWindow.propTypes = {
    href: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.object,
};

export default MapInfoWindow;
